import { Tooltip } from "@mui/material";
import { useState } from "react";

const IntSwitchButton = (props) => {
  const { switchVal } = props;
  const handleSwitch = () => {
    props.handleSwitchButton(!switchVal);
  }
 
  let clasList = ``;
  if (props.single) {
    clasList = `flex justify-end mb-[5px] max-[1100px]:justify-start`;
  } else if (props.noFloat) {
    clasList = `flex mb-[10px] flex-shrink-0`;
  } else {
    clasList = `inline-flex mr-[33px] mb-[20px] min-[601px]:absolute min-[601px]:bottom-0 min-[601px]:right-[-17px] max-[600px]:mt-[10px]`
  }
  return (
    <div className={`items-center ${clasList}`}>
      <div className="p-[3px] text-white text-[13px] font-[600] bg-[#0F59F9] rounded-[4px] relative z-[10]">
        <span className="inline-block py-[3px] px-[10px]">LT</span>
        <span className="inline-block py-[3px] px-[10px]">HT</span>
        <span className={`cursor-pointer switch_wt_bx absolute top-[50%] -translate-y-[50%] ${switchVal ? 'right-[3px]' : 'right-[53%]'} h-[85%] w-[44%] bg-white rounded-[4px]`} onClick={handleSwitch}></span>
      </div>
      <Tooltip title="coming soon">
        <img src="/images/fi_info.svg" alt="info" className="ml-[10px]" />
      </Tooltip>
    </div>
  )
};

export default IntSwitchButton;
